import React from 'react'

export default function TypeLarge({ questiondata, setQuestionData }: any): JSX.Element {
    return (
        <div>
            <h5>Los alumnos responderán la pregunta de forma libre y explayada</h5>
        </div>
    )
}
